import { render, staticRenderFns } from "./PointGpayConfirm.vue?vue&type=template&id=c417fd50"
import script from "./PointGpayConfirm.vue?vue&type=script&lang=js"
export * from "./PointGpayConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports